//@ts-nocheck
/** Build Stripe's return destination without forwarding a browser fragment. */
export const sanitizeStripeReturnUrl = (href) => {
  if (typeof href !== 'string') {
    throw new TypeError('Stripe return URL must be an absolute HTTP(S) URL');
  }

  const url = new URL(href);
  if (url.protocol !== 'http:' && url.protocol !== 'https:') {
    throw new TypeError('Stripe return URL must use HTTP(S)');
  }

  url.hash = '';
  return url.href;
};
